import { Component, Input } from '@angular/core';

@Component({
  selector: 'refactor-card-header',
  standalone: false,
  templateUrl: './refactor-card-header.component.html',
  styleUrl: './refactor-card-header.component.scss'
})
export class RefactorCardHeaderComponent {
  @Input() title: string = 'Generación del proceso de refactorización de Código';
  @Input() subtitle: string = '(Migraciones versiones: Java y modernización del legacy)';
}
